// Copied from admin-dashboard (`src/utils/encryption.ts`): apps never import each other's src. Move both to a shared package if it changes.
class Encryption {
  private refCharSet =
    ',_.-=><*:!(){}[]0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ'

  public encrypt(str: string, secret: string): string {
    if (secret == '0') {
      return str
    }
    const shiftStrSet = secret.split('.')
    let encrypted = this.generateCipher(str, shiftStrSet[0])
    for (let i = 1; i < shiftStrSet.length; i++) {
      encrypted = this.scrambleString(encrypted, shiftStrSet[i])
    }
    return encrypted
  }

  public decrypt(encrypted: string, secret: string): string {
    if (secret == '0') {
      return encrypted
    }
    const shiftStrSet = secret.split('.')
    let decrypted = encrypted
    for (let i = shiftStrSet.length - 1; i > 0; i--) {
      decrypted = this.unscrambleString(decrypted, shiftStrSet[i])
    }
    return this.decipher(decrypted, shiftStrSet[0])
  }

  private generateCipher(str: string, shiftStr: string): string {
    const refCharArray = this.refCharSet.split('')
    let cipherText = ''

    for (let i = 0; i < str.length; i++) {
      let shift = shiftStr.charCodeAt(i % shiftStr.length)
      shift = shift >= 48 && shift <= 57 ? shift - 48 : shift % refCharArray.length

      const index = refCharArray.indexOf(str[i])

      if (index !== -1) {
        cipherText += refCharArray[(index + shift) % refCharArray.length]
      } else {
        cipherText += str[i]
      }
    }

    return cipherText
  }

  private decipher(cipherText: string, shiftStr: string): string {
    const refCharArray = this.refCharSet.split('')
    let plainText = ''

    for (let i = 0; i < cipherText.length; i++) {
      let shift = shiftStr.charCodeAt(i % shiftStr.length)
      shift = shift >= 48 && shift <= 57 ? shift - 48 : shift % refCharArray.length

      const index = refCharArray.indexOf(cipherText[i])

      if (index !== -1) {
        plainText += refCharArray[(index - shift + refCharArray.length) % refCharArray.length]
      } else {
        plainText += cipherText[i]
      }
    }

    return plainText
  }

  private scrambleString(str: string, shiftStr: string): string {
    if (str.length < 2) return str
    const charArray = str.split('')

    for (let i = 0; i < str.length; i++) {
      const shift = shiftStr.charCodeAt(i % shiftStr.length)
      const newIndex = (shift >= 48 && shift <= 57 ? shift - 48 : shift) % str.length

      const temp = charArray[i]
      charArray[i] = charArray[newIndex]
      charArray[newIndex] = temp
    }

    return charArray.join('')
  }

  private unscrambleString(str: string, shiftStr: string): string {
    if (str.length < 2) return str
    const charArray = str.split('')

    for (let i = str.length - 1; i >= 0; i--) {
      const shift = shiftStr.charCodeAt(i % shiftStr.length)
      const originalIndex = (shift >= 48 && shift <= 57 ? shift - 48 : shift) % str.length

      const temp = charArray[i]
      charArray[i] = charArray[originalIndex]
      charArray[originalIndex] = temp
    }

    return charArray.join('')
  }
}

export default new Encryption()
